import styles from "./AdditionalAmenitiesModal.module.scss";
import { TiMinus, TiPlus } from "react-icons/ti";
import { Switch } from "react-animated-switch";
import Modal from "../../Common/Modal/Modal";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  parkingOptions?: {
    parkingId: number;
    amenityName: string;
    noOfCars: number;
    noOfBicycle: number;
    availableNoOfCars: number;
    availableNoOfBicycle: number;
    costCar: number;
    costBicycle: number;
  };
  parkingSelections: {
    parkingId: string;
    noofCars: number;
    noofBicycle: number;
    notice: boolean;
  };
  setParkingSelections: React.Dispatch<
    React.SetStateAction<{
      parkingId: string;
      noofCars: number;
      noofBicycle: number;
      notice: boolean;
    }>
  >;
}

const AdditionalAmenitiesModal = (props: Props) => {
  const {
    isOpen,
    setIsOpen,
    parkingOptions,
    parkingSelections,
    setParkingSelections,
  } = props;

  const subtractCounterHandler = (type: "car" | "bicycle") => {
    let prev: any = {
      ...parkingSelections,
      parkingId: parkingOptions?.parkingId,
    };
    if (type === "car") {
      if (parkingSelections.noofCars > 0) {
        prev.noofCars = prev.noofCars - 1;
        setParkingSelections(prev);
      }
    }
    if (type === "bicycle") {
      if (parkingSelections.noofBicycle > 0) {
        prev.noofBicycle = prev.noofBicycle - 1;
        setParkingSelections(prev);
      }
    }
  };

  const addCounterHandler = (type: "car" | "bicycle") => {
    let prev: any = {
      ...parkingSelections,
      parkingId: parkingOptions?.parkingId,
    };
    if (type === "car") {
      if (parkingSelections.noofCars < (parkingOptions?.noOfCars ?? 0)) {
        prev.noofCars = prev.noofCars + 1;
        setParkingSelections(prev);
      }
    }

    if (type === "bicycle") {
      if (parkingSelections.noofBicycle < (parkingOptions?.noOfBicycle ?? 0)) {
        prev.noofBicycle = prev.noofBicycle + 1;
        setParkingSelections(prev);
      }
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={true}>
      <div className={styles.additionalAmenitiesModalContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.heading}>Select Additional Amenities</p>
        </div>
        <div className={styles.parkingContainer}>
          <div className={styles.contentContainer}>
            {parkingSelections.noofCars >
              (parkingOptions?.availableNoOfCars ?? 0) && (
              <div className={styles.notAvailableContainer}>
                <p className={styles.label}>Not Available</p>
              </div>
            )}
            <div className={styles.contentInnerContainer}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Car Parking</p>
              </div>
              <div className={styles.counterContainer}>
                <button
                  className={styles.counterButton}
                  onClick={() => subtractCounterHandler("car")}
                >
                  <TiMinus />
                </button>
                <p className={styles.counterValue}>
                  {parkingSelections?.noofCars}
                </p>
                <button
                  className={styles.counterButton}
                  onClick={() => addCounterHandler("car")}
                >
                  <TiPlus />
                </button>
              </div>
              <div className={styles.priceContainer}>
                <p>
                  ${" "}
                  {(parkingOptions?.costCar ?? 0) * parkingSelections.noofCars}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.parkingContainer}>
          <div className={styles.contentContainer}>
            {parkingSelections.noofBicycle >
              (parkingOptions?.availableNoOfBicycle ?? 0) && (
              <div className={styles.notAvailableContainer}>
                <p className={styles.label}>Not Available</p>
              </div>
            )}
            <div className={styles.contentInnerContainer}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Bicycle Parking</p>
              </div>
              <div className={styles.counterContainer}>
                <button
                  className={styles.counterButton}
                  onClick={() => subtractCounterHandler("bicycle")}
                >
                  <TiMinus />
                </button>
                <p className={styles.counterValue}>
                  {parkingSelections?.noofBicycle}
                </p>
                <button
                  className={styles.counterButton}
                  onClick={() => addCounterHandler("bicycle")}
                >
                  <TiPlus />
                </button>
              </div>
              <div className={styles.priceContainer}>
                <p>
                  ${" "}
                  {(parkingOptions?.costBicycle ?? 0) *
                    parkingSelections.noofBicycle}
                </p>
              </div>
            </div>
          </div>
          {(parkingSelections.noofCars >
            (parkingOptions?.availableNoOfCars ?? 0) ||
            parkingSelections.noofBicycle >
              (parkingOptions?.availableNoOfBicycle ?? 0)) && (
            <div className={styles.noticeContainer}>
              <div className={styles.switchContainer}>
                <Switch
                  inActiveTrackColor="#DFDFDF"
                  activeTrackColor="#C0F496"
                  inActiveThumbColor="#000000"
                  activeThumbColor="#000000"
                  checked={parkingSelections.notice}
                  onChange={(val) =>
                    setParkingSelections((prev: any) => ({
                      ...prev,
                      notice: val,
                    }))
                  }
                />
              </div>
              <p className={styles.label}>
                Notify me when parking is available
              </p>
            </div>
          )}
        </div>

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={() => setIsOpen(false)}>
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AdditionalAmenitiesModal;
